import client from './client';

const endpoint = "/login";

const login = (username, password) => client.post(endpoint, { username, password });

export default
    {
        login,
    }